<template>
  <div>
    <div v-if="!loading" class="margin-bottom-10">
      <button v-if="!forms.hasOwnProperty('profile')" class="btn green"
              @click.prevent="addForm('profile')">
        Add Profile Form
      </button>
      <button v-if="!forms.hasOwnProperty('assignment')" class="btn green"
              @click.prevent="addForm('assignment') ">Add Status Form
      </button>
      <button v-if="!forms.hasOwnProperty('contact')" class="btn green"
              @click.prevent="addForm('contact')">
        Add Contact Form
      </button>
    </div>

    <base-form-index
      :loading="loading"
      :rows="rows"
      :columns="columns"
      @form-removed="fetchSystemForms"
    />
    <add-form-modal v-if="showAddFormModal"
                    v-on:hide="showAddFormModal = false"
                    :modules="modules"
                    :preselected-module="preselectedModule"
                    :lock-module-select="true"/>
  </div>
</template>

<script>
import BaseFormIndex from "./BaseFormIndex";
import Breadcrumbs from '@/components/Breadcrumbs'
import {mapGetters, mapActions} from "vuex";
import AddFormModal from "../modals/AddFormModal";

export default {
  data() {
    return {
      columns: [
        {
          label: 'Related To',
          field: 'module_name',
          filterOptions: {enabled: true}
        },
        {
          label: 'Name',
          field: 'name',
          html: true,
          filterOptions: {enabled: true}
        },
        {
          label: 'Description',
          field: 'description',
          filterOptions: {enabled: true}
        },
        {
          label: 'Status',
          field: 'publish',
          filterOptions: {enabled: true}
        },
        {
          label: 'Created By',
          field: 'created_date',
          filterOptions: {enabled: true}
        },
        {
          label: 'Last Modified',
          field: 'last_modification_date',
          filterOptions: {enabled: true}
        },
        {
          label: 'Actions',
          field: 'actions',
          sortable: false,
        }
      ],
      activeTab: 'system-forms',
      showAddFormModal: false,
      preselectedModule: null,
    }
  },

  mounted() {
    this.fetchSystemForms();
  },

  components: {
    BaseFormIndex,
    AddFormModal,
    'breadcrumb-bar': Breadcrumbs
  },

  computed: {
    ...mapGetters({
      'loading': 'getSystemFormsLoading',
      'forms': 'getSystemForms',
      'modules': 'getSystemFormsModules'
    }),

    rows() {
      let rows = [{}, {}, {}];
      Object.entries(this.forms).forEach(([key, row]) => {

        let date = this.$options.filters.formatDate(row.created_date.date);
        row.created_date = row.user + ' on ' + date;

        if (row.last_modification_date) {
          date = this.$options.filters.formatDate(row.last_modification_date);
        }

        if (row.last_action_user) {
          row.last_modification_date = row.last_action_user + ' on ' + date;
        }

        if (key == 'profile') {
          rows[0] = row;
        }

        if (key == 'assignment') {
          rows[1] = row;
        }

        if (key == 'contact') {
          rows[2] = row;
        }
      });
      return rows.filter(row => Object.keys(row).length !== 0);
    }
  },

  methods: {
    ...mapActions([
      'fetchSystemForms'
    ]),
    addForm(type) {
      this.preselectedModule = (this.modules.find(module => module.role === type)).key;
      this.showAddFormModal = true;
    },
  },
}
</script>




// WEBPACK FOOTER //
// SystemFormsIndex.vue?60e922e8